import type { FieldCodec, OptionRef } from 'v5/core/entity-values/values.types';
import { splitOptionRefs } from './optionRefs';
import { validateField, validation } from './validation';

function isEmpty(value: OptionRef[]): boolean {
  return value.length === 0;
}

/** Resource groups: existing ids plus names to create (always creatable). */
export const groupsCodec: FieldCodec<'groups'> = {
  decode(entity) {
    return (entity.groups ?? []).map(group => ({
      type: 'existing',
      id: group.id
    }));
  },
  encode(value) {
    const { ids, create } = splitOptionRefs(value);
    return { type: 'groups', ids, create };
  },
  empty() {
    return [];
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, value =>
      value.some(ref => ref.type === 'new' && ref.label.trim() === '')
        ? validation.invalid({ code: 'part-required', part: 'group-name' })
        : validation.valid()
    );
  }
};
